import { getRequest, formatDateInvariant } from "../util/util.js";
import { createStoryCardScroll } from "../modules/storyCardsGalleryOverflowRow.js"

// Elements
const selectCategory = document.getElementById("search-category");
const searchInputElem = document.getElementById("search-term");
const blogContainer = document.getElementById("view-blog-container");
const loadMoreBtn = document.getElementById("load-more-btn");
const viewPageUrl = document.getElementById("view-page-url");
const mainChannelCategoryGroupWrapper = document.getElementById("mainChannel-category-group-wrapper");

//Config
const API_BASE = `${location.origin}/umbraco/api/MainChannelAPI`;
const endpoints = {
    all: "GetAllMainChannelContentData",
    category: "GetAllMainChannelContentByCategory",
    search: "GetMainChannelContentFromSearch",
    categoryGroups: "GetAllCategoryGroups",
    viewAllPageURL:"GetViewAllPageURL"
};
const MainChannelViewAllPageURL = await getRequest(`${API_BASE}/${endpoints.viewAllPageURL}`);
const TAKE = 10;

// determine if on view-page
const isViewPage = !!(viewPageUrl) && (viewPageUrl.dataset.current === viewPageUrl.value);


// Event Handlers
function handleChangeEvent(type, value) {
    const url = new URL(location.href);
    url.search = "";
    if (value) url.searchParams.set(type, value);
    window.history.pushState({}, "", url);
    updateContent();
}

// Fetch and update content
async function updateContent(append = false) {
    if (!blogContainer) return;

    const params = new URLSearchParams(location.search);
    const searchTerm = params.get("searchTerm");
    const category = params.get("category");
    const skip = append ? blogContainer.childElementCount : 0;

    let url;
    if (searchTerm) {
        selectCategory.value = ""
        url = `${API_BASE}/${endpoints.search}?searchTerm=${encodeURIComponent(searchTerm)}&skip=${skip}&take=${TAKE}`;
    } else if (category) {
        searchInputElem.querySelector(`input[type="search"]`).value = ""
        url = `${API_BASE}/${endpoints.category}?category=${encodeURIComponent(category)}&skip=${skip}&take=${TAKE}`;
    } else {
        url = `${API_BASE}/${endpoints.all}?skip=${skip}&take=${TAKE}`;
    }

    const response = await getRequest(url);
    if (!response) {
        console.log(response)
        return;
    }

    const { returnData = [], totalCount = 0 } = response;
    if (!append) {
        blogContainer.innerHTML = "";
    }
    blogContainer?.setAttribute("data-blog-count", totalCount)
    const frag = document.createDocumentFragment();
    returnData.forEach(item => frag.appendChild(createCardElem(item)));
    blogContainer.append(frag);
    const currentCount = blogContainer.childElementCount;
    if (loadMoreBtn) {
        loadMoreBtn.disabled = currentCount >= totalCount;
    }
}

//Initialization
if (isViewPage) {
    updateContent();
    selectCategory?.addEventListener("change", (e) => handleChangeEvent("category", e.target.value));
    const input = searchInputElem?.querySelector(`input[type="search"]`);
    searchInputElem?.querySelector(`[role="button"]`)?.addEventListener("click", (e) => handleChangeEvent("searchTerm", input?.value));
    input?.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
            handleChangeEvent("searchTerm", input.value)
        }
    });
    loadMoreBtn?.addEventListener('click', () => updateContent(true));
}

///**
// * @typedef {Object} ImageUrlObject
// * @property {number} id
// * @property {(string|number)} height  
// * @property {(string|number)} width
// * @property { URL} url - url of image
// * @property {string} altText
// * 
// * @typedef {Object} IItem
// * @property { number } id
// * @property {string} category     
// * @property {string} title - Page Title
// * @property {string} description - Short teaser description
// * @property {boolean} isFeatured
// * @property {ImageUrlObject} desktopImage - Image
// * @property {ImageUrlObject} mobileImage 
// */

/**    
 * @param {IItem} item - Input from api
 * @returns {HTMLAnchorElement} - Returns Card elem for displaying.
 */
function createCardElem(item) {
    const { category, title, description, pageURL = "", desktopImageCropper, mobileImageCropper, updatedDate, isFeatured } = item;
    const anchor = document.createElement("a");
    anchor.href = pageURL || "#";
    anchor.setAttribute("title", title);
    anchor.innerHTML = `
    <article class="relative theme-dark rounded">
      <picture>
        <source srcset="${mobileImageCropper}" media="(max-width:800px)" width="375" height="375" />
        <img class="w-full rounded" src="${desktopImageCropper}" loading="lazy" width="800" height="600" alt="${title}" />
      </picture>
      ${isFeatured ?
            `<span class="text-base/snug absolute left-2 top-2 rounded bg-white px-8 py-2 text-[#707070]">Featured</span>`
            :
            ""}
      <div class="absolute inset-4 lg:inset-8 inline-flex flex-col justify-end blogs-start">
        <div>
          <div>
            <p class="text-sm italic">${formatDateInvariant(updatedDate)}</p>
            <span class="uppercase">${category}</span>
            <h4>${title}</h4>
            <p>${description}</p>
          </div>
        </div>
      </div>
    </article>`.trim();
    return anchor;
}

if (mainChannelCategoryGroupWrapper) {
    let url = `${API_BASE}/${endpoints.categoryGroups}`;

    const response = await getRequest(url);
    if (!response) {
        console.log("Error Occured fetching Category Data" + response)
    }
    else {
        mainChannelCategoryGroupWrapper.innerHTML = "";
        response.components.forEach(component => {

            if (component.isVertical) {
                var VerticalCarouselHTML = createVerticalCarousel(component, { MainChannelViewAllPageURL });
                mainChannelCategoryGroupWrapper.appendChild(VerticalCarouselHTML);
            }
            else {
                var HorizontalCarouselHTML = createHorizontalCarousel(component, { MainChannelViewAllPageURL });
                mainChannelCategoryGroupWrapper.appendChild(HorizontalCarouselHTML);
                createStoryCardScroll(HorizontalCarouselHTML);
            }

        })

    }

}

function createVerticalCarousel(component,options) {
    const viewAllPageUrl = options?.MainChannelViewAllPageURL.url || "";
    const themeOverride = component?.theme === "light";
    const uniqueId = Math.floor(Math.random() * 1000000000);

    const category = component?.categoryGroup ? component?.categoryGroup?.category : "Popular"

    const description = component?.description || "";
    const displayBlogs = Array.isArray(component?.categoryGroup?.data)
                        ? component.categoryGroup.data: Array.isArray(component?.popularGroup?.data)
                        ? component.popularGroup.data : [];

    const viewQuery = viewAllPageUrl
                    ? `${viewAllPageUrl}${viewAllPageUrl.includes("?") ? "&" : "?"}category=${encodeURIComponent(category)}`
                    : `?category=${encodeURIComponent(category)}`;

    const cardsHtml = displayBlogs
                    .filter((item) => item?.desktopImageCropper)
                    .map((item) => createVerticalCardHtml(item,category))
                    .join("");

    const sectionHTML = `
<section class="${themeOverride ? "theme-light" : "theme-dark"} py-[var(--stacked-component-sm)] relative"
  id="vertical-features"
  data-alias-name="featureOverflowVerticalScrollComponent"
  data-unique-id="${uniqueId}">
  <div class="max-w-[var(--container-width-xl)] px-[var(--container-padding)] mx-auto flex flex-col gap-10 lg:flex-row lg:items-start lg:justify-between lg:gap-20">
    <div class="flex flex-col items-start lg:top-[var(--masthead-height-combined)] lg:sticky lg:left-0 lg:w-1/3">
      <h3>${escapeText(category).toUpperCase()}</h3>
      ${description && String(description).trim().length > 0 ? `<p class="text-sm/snug">${escapeText(description)}</p>` : ""}
      <div class="inline-block">
        <a class="text-link" href="${viewQuery}">View All</a>
      </div>
    </div>
    <div id="overflow-container-${uniqueId}" class="px-[var(--container-padding)] lg:w-2/3 lg:max-w-4xl">
      <div id="overflow-wrapper-${uniqueId}" class="learning-collective-carousel relative">
        <button id="previous-${uniqueId}" title="Previous Items" class="scroll-button secondary previous md:hidden" type="button">
          <svg class="size-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 19L3 12L10 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M3 12H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>

        <button id="next-${uniqueId}" title="Next Items" class="secondary scroll-button next md:hidden" type="button">
          <svg class="size-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 5L21 12L14 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M21 12H3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>

        <div id="overflow-scroll-${uniqueId}" class="vertical-feature-items snap-x snap-mandatory scroll-smooth">
          ${cardsHtml}
        </div>
      </div>
    </div>
  </div>
</section>`.trim();

    const tpl = document.createElement("template");
    tpl.innerHTML = sectionHTML;
    return tpl.content.firstElementChild;
}

function createVerticalCardHtml(item, groupCategory) {
    const pageURL = item?.pageURL || "#";
    const title = item?.title || "";
    const description = item?.description || "";
    const category = item?.category || "";
    const badgeText = item?.badgeText || "";
    const desktopImageCropper = item?.desktopImageCropper || "";
    const mobileImageCropper = item?.mobileImageCropper || "";
    const updatedDate = item?.updatedDate;
    const isPopular = groupCategory == "Popular";


    return `
<div class="storyCardsGalleryItem relative shrink-0 basis-full snap-start lg:basis-auto">
  <a href="${pageURL}" title="${escapeAttr(title)}">
    <article class="theme-dark relative rounded">
      <picture>
        <source srcset="${mobileImageCropper || desktopImageCropper}" media="(max-width:800px)" />
        <img class="w-full rounded" src="${desktopImageCropper}" loading="lazy" alt="${escapeAttr(title)}" />
      </picture>

      <div class="blogs-start absolute inset-4 inline-flex flex-col justify-end lg:inset-8">
        ${badgeText ? `<span class="text-base/snug absolute top-4 w-auto rounded bg-white px-8 py-2 font-bold text-black opacity-50">${escapeText(badgeText)}</span>` : ""}
        ${isPopular == true ? `<span class="text-base/snug absolute top-4 right-0 w-auto rounded bg-white px-8 py-2 font-bold text-black opacity-50">POPULAR</span>` :``}
        <div>
          <p class="text-sm italic">${formatDateMMddyyyy(updatedDate)}</p>
          <span class="uppercase">${escapeText(category)}</span>
          <h4>${escapeText(title)}</h4>
          <p>${escapeText(description)}</p>
        </div>
      </div>
    </article>
  </a>
</div>`.trim();
}

function formatDateMMddyyyy(value) {
    const d = value ? new Date(value) : null;
    if (!d || Number.isNaN(d.getTime())) return "";
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const yyyy = String(d.getFullYear());
    return `${mm}/${dd}/${yyyy}`;
}

function escapeText(value) {
    return String(value ?? "")
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#39;");
}

function escapeAttr(value) {
    return escapeText(value);
}

function createHorizontalCarousel(component, options) {
    const viewAllPageUrl = options?.MainChannelViewAllPageURL.url || "";
    const aliasName = options?.aliasName || "LearningCreativeComponentGroupItem";
    const themeOverride = component?.theme === "dark";
    const uniqueId = Math.floor(Math.random() * 1000000000);

    const category = component?.categoryGroup ? component?.categoryGroup?.category :"Popular"

    const displayBlogs = Array.isArray(component?.categoryGroup?.data)
        ? component.categoryGroup.data
        : Array.isArray(component?.popularGroup?.data)
            ? component.popularGroup.data
            : [];

    const viewQuery = viewAllPageUrl
        ? `${viewAllPageUrl}${viewAllPageUrl.includes("?") ? "&" : "?"}category=${encodeURIComponent(category)}`
        : `?category=${encodeURIComponent(category)}`;

    const cardsHtml = displayBlogs
        .filter((item) => item?.desktopImageCropper)
        .map((item) => createHorizontalCardHtml(item, category))
        .join("");

    const html = `
<section class="${themeOverride ? "theme-dark" : "theme-light"} max-w-[var(--container-width-xl)] px-[var(--container-padding)] py-[var(--stacked-component-sm)] relative mx-auto"
  data-overflow-scrollgallary
  data-alias-name="${escapeAttr(aliasName)}"
  data-unique-id="${uniqueId}">
  <div class="pb-[var(--stacked-component-sm)] flex flex-col gap-4 lg:flex-row lg:gap-10">
    <h2>${escapeText(category).toUpperCase()}</h2>
    <div class="inline-block self-start lg:self-end">
      <a class="text-link" href="${viewQuery}">View All</a>
    </div>
  </div>

  <div id="overflow-container-${uniqueId}" class="relative">
    <div id="overflow-wrapper-${uniqueId}" class="learning-collective-carousel relative overflow-hidden">
      <button id="previous-${uniqueId}" title="Previous Items" class="scroll-button secondary previous">
        <svg class="size-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 19L3 12L10 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M3 12H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>

      <button id="next-${uniqueId}" title="Next Items" class="secondary scroll-button next">
        <svg class="size-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 5L21 12L14 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M21 12H3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>

      <div id="overflow-scroll-${uniqueId}" class="overflow-scroll-container">
        ${cardsHtml}
      </div>
    </div>
  </div>
</section>`.trim();

    const tpl = document.createElement("template");
    tpl.innerHTML = html;
    return tpl.content.firstElementChild;
}

function createHorizontalCardHtml(item,groupCategory) {
    const pageURL = item?.pageURL || "#";
    const title = item?.title || "";
    const description = item?.description || "";
    const category = item?.category || "";
    const badgeText = item?.badgeText || "";
    const desktopImageCropper = item?.desktopImageCropper || "";
    const mobileImageCropper = item?.mobileImageCropper || "";
    const updatedDate = item?.updatedDate;
    const isPopular = groupCategory == "Popular";

    return `
<div class="storyCardsGalleryItem relative shrink-0 basis-full snap-start lg:basis-auto">
  <a href="${pageURL}" title="${escapeAttr(title)}">
    <article class="theme-dark relative rounded">
      <picture>
        <source srcset="${mobileImageCropper || desktopImageCropper}" media="(max-width:800px)"/>
        <img class="w-full rounded" src="${desktopImageCropper}" loading="lazy" alt="${escapeAttr(title)}" />
      </picture>

      <div class="blogs-start absolute inset-4 inline-flex flex-col justify-end lg:inset-8">
        ${badgeText ?
        `<span class="text-base/snug absolute top-4 w-auto rounded bg-white px-8 py-2 font-bold text-black opacity-50">${escapeText(badgeText)}</span>`
        : ""}
                ${isPopular == true ? `<span class="text-base/snug absolute top-4 right-0 w-auto rounded bg-white px-8 py-2 font-bold text-black opacity-50">POPULAR</span>` : ``}

        <div>
          <p class="text-sm italic">${formatDateMMddyyyy(updatedDate)}</p>
          <span class="uppercase">${escapeText(category)}</span>
          <h4>${escapeText(title)}</h4>
          <p>${escapeText(description)}</p>
        </div>
      </div>
    </article>
  </a>
</div>`.trim();
}